/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-user\":\"Circle with user profile\"}");